import {
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  USER_UPDATE_DETAILS_REQUEST,
  USER_UPDATE_DETAILS_SUCCESS,
  USER_UPDATE_DETAILS_FAIL,
  USER_UPDATE_DETAILS_RESET,
  USERS_ADMIN_LIST_REQUEST,
  USERS_ADMIN_LIST_SUCCESS,
  USERS_ADMIN_LIST_FAIL,
} from '../constants/userConstants';

export const userReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
    case USER_REGISTER_REQUEST:
    case USER_DETAILS_REQUEST:
    case USER_UPDATE_DETAILS_REQUEST:
      return { ...state, loading: true };
    case USER_LOGIN_SUCCESS:
    case USER_REGISTER_SUCCESS:
    case USER_DETAILS_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
        userInfo: action.payload,
        success: false,
      };
    case USER_UPDATE_DETAILS_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
        userInfo: action.payload,
        success: true,
      };
    case USER_LOGIN_FAIL:
    case USER_REGISTER_FAIL:
    case USER_DETAILS_FAIL:
    case USER_UPDATE_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case USER_LOGOUT:
    case USER_UPDATE_DETAILS_RESET:
      return {};
    default:
      return state;
  }
};

export const userAdminListReducer = (state = {}, action) => {
  switch (action.type) {
    case USERS_ADMIN_LIST_REQUEST:
      return { ...state, loading: true };
    case USERS_ADMIN_LIST_SUCCESS:
      return { loading: false, users: action.payload };
    case USERS_ADMIN_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
